import { createSlice, createSelector, isPending, isRejected, isFulfilled } from "@reduxjs/toolkit";
import axios from "axios";
import { views } from "./utils";
import { AppViews } from "../utils";

axios.defaults.headers.common["AgencyID"] = window.configData.AGENCYID;
axios.defaults.headers.common["Version"] = import.meta.env.VITE_APP_VERSION;
axios.defaults.headers.common["App"] = window.configData.APP;

const defaultSearchReducer = [
  { property: "category", offset: -3 },
  { property: "duration", offset: -1 },
  { property: "directflight", offset: false },
];

const initialState = {
  loading: 0,
  error: "",
  socketid: "",
  view: undefined,
  viewBeforeSearch: views.homeview,
  sessionId: "",
  accountid: "",
  isloadertext: true,
  sidebar: false,
  map: false,
  urlfound: false,
  mode: "production",
  features: false,
  searchQuery: "",
  debug: false,
  saveSearch: true,
  searchEnded: true,
  openSearch: false,
  isNativeApp: false,
  isIFrame: false,
  // Widget-Betrieb: zeigt alle Kategorie-Badges, unabhaengig von den
  // Einzel-Flags der Agentur. Wird von ibe_searchwidget gesetzt.
  premiumSearch: false,
  searchReducer: defaultSearchReducer,
};

export const systemSlice = createSlice({
  name: "system",
  initialState,
  reducers: {
    setSocketid: (state, action) => {
      state.socketid = action.payload;
    },
    setViewBeforeSearch: (state, action) => {
      state.viewBeforeSearch = action.payload;
    },
    setView: (state, action) => {
      state.view = action.payload;
    },
    setIFrame: (state, action) => {
      state.isIFrame = action.payload;
    },
    setNativeApp: (state, action) => {
      state.isNativeApp = action.payload;
    },
    setIsloadertext: (state, action) => {
      state.isloadertext = action.payload;
    },
    setSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
    setPremiumSearch: (state, action) => {
      state.premiumSearch = action.payload;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setAccountId: (state, action) => {
      state.accountid = action.payload;
    },

    addLoading: (state) => {
      state.loading = state.loading + 1;
    },
    decLoading: (state) => {
      state.loading = state.loading - 1;
    },
    setSidebar: (state, action) => {
      state.sidebar = action.payload;
    },
    setOpenSearch: (state, action) => {
      state.openSearch = action.payload;
    },
    setMap: (state, action) => {
      state.map = action.payload;
    },
    setUrlfound: (state, action) => {
      state.urlfound = action.payload;
    },
    setFeatures: (state, action) => {
      state.features = action.payload;
    },
    setMode: (state, action) => {
      state.mode = action.payload;
    },
    setDebug: (state, action) => {
      state.debug = action.payload;
    },
    setSaveSearch: (state, action) => {
      state.saveSearch = action.payload;
    },
    setSearchEnded: (state, action) => {
      state.searchEnded = action.payload;
    },
    setSearchReducer: (state, action) => {
      state.searchReducer = action.payload;
    },
    resetSearchReducer: (state) => {
      state.searchReducer = defaultSearchReducer;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isPending, (state, action) => {
      if (action.type.startsWith("offers/searchOffers") || action.type.startsWith("hotel/searchHotelOffers")) {
        state.loading += 1;
      }
      state.error = "";
    });
    builder.addMatcher(isRejected, (state, action) => {
      if (action.type.startsWith("offers/searchOffers") || action.type.startsWith("hotel/searchHotelOffers")) {
        state.loading -= 1;
      }
      state.error = action?.payload?.error;
    });
    builder.addMatcher(isFulfilled, (state, action) => {
      if (action.type.startsWith("offers/searchOffers") || action.type.startsWith("hotel/searchHotelOffers")) {
        state.loading -= 1;
      }
      state.error = "";
    });
  },
});

// ✅ FIXED: Input selectors extract stable references, result function creates the object
export const selectSystem = createSelector(
  (state) => state.system.loading,
  (state) => state.system.error,
  (state) => state.system.view,
  (state) => state.system.sidebar,
  (loading, error, view, sidebar) => ({
    loading,
    error,
    view,
    sidebar,
  }),
);

export const {
  setView,
  setSessionId,
  setPremiumSearch,
  setAccountId,
  setDebug,
  setSidebar,
  setMap,
  setUrlfound,
  setFeatures,
  setSaveSearch,
  setSearchEnded,
  setMode,
  setSearchQuery,
  setOpenSearch,
  setSocketid,
  setViewBeforeSearch,
  addLoading,
  decLoading,
  setIsloadertext,
  setNativeApp,
  setIFrame,
  setSearchReducer,
  resetSearchReducer,
} = systemSlice.actions;

export default systemSlice.reducer;
